import React from "react";
import { motion } from "framer-motion";
import { ListChecks, UserCheck, CheckCircle2 } from "lucide-react";
import { useLang } from "../i18n";

const icons = [ListChecks, UserCheck, CheckCircle2];

export default function HowItWorks() {
  const { t } = useLang();
  return (
    <section id="how" className="py-24 md:py-40 bg-crema" data-testid="how-section">
      <div className="mx-auto max-w-7xl px-5 md:px-10">
        <motion.h2
          initial={{ opacity: 0, y: 24 }}
          whileInView={{ opacity: 1, y: 0 }}
          viewport={{ once: true }}
          transition={{ duration: 0.7 }}
          className="font-display font-black tracking-tight text-charcoal text-4xl md:text-5xl mb-16 md:mb-24"
          data-testid="how-title"
        >
          {t.how.title}
        </motion.h2>

        <div className="grid md:grid-cols-3 gap-14 md:gap-10">
          {t.how.steps.map((step, i) => {
            const Icon = icons[i];
            return (
              <motion.div
                key={i}
                initial={{ opacity: 0, y: 40 }}
                whileInView={{ opacity: 1, y: 0 }}
                viewport={{ once: true, margin: "-60px" }}
                transition={{ duration: 0.7, delay: i * 0.12, ease: [0.16, 1, 0.3, 1] }}
                className="relative"
                data-testid={`how-step-${i + 1}`}
              >
                <div className="flex items-baseline gap-4 mb-6">
                  <span className="font-display font-black text-6xl md:text-7xl text-charcoal/10 leading-none">
                    0{i + 1}
                  </span>
                  <Icon className="h-7 w-7 text-teal shrink-0" strokeWidth={1.8} />
                </div>
                <h3 className="font-display font-bold text-2xl text-charcoal leading-snug mb-3">
                  {step.t}
                </h3>
                <p className="text-warmgray text-base md:text-lg leading-relaxed">{step.d}</p>
              </motion.div>
            );
          })}
        </div>
      </div>
    </section>
  );
}
